const TELEPHONE_RE = /[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/

// Used for detecting if text contains an email (e.g., rejecting messages with emails)
const EMAIL_RE = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/

// Used for validating that a string is a properly formatted email address
const EMAIL_VALIDATION_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,})+$/

const containsPhoneNumber = (input) => {
    return TELEPHONE_RE.test(input)
}

const containsEmail = (input) => {
    return EMAIL_RE.test(input)
}

export const containsPhoneNumberOrEmail = (input) => {
    return containsPhoneNumber(input) || containsEmail(input)
}

/**
 * Validates that a string is a properly formatted email address.
 * Uses a regex pattern optimized to avoid catastrophic backtracking.
 * 
 * @param {string|null|undefined} input - The string to validate
 * @returns {boolean} True if input is a valid email format, false otherwise
 */
export const isValidEmail = (input) => {
  if (input == null || typeof input !== 'string') {
    return false
  }
  return EMAIL_VALIDATION_REGEX.test(input)
}
